import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ProfileState = {
	id: '',
	first_name: '',
	last_name: '',
	gender: '',
	email: '',
	phone: '',
	birth_date: '',
	street: '',
	city: '',
	unit: '',
	postal_code: '',
	cards: [],
	favorite_products: [],
	favorite_stores: [],
	eward_subscription: false,
	eward_signup_date: '',
	birthday_promotion_medium: '',
	reward_progress: [],
	claimed_rewards: [],
	bad_email: false,
	accepted_terms_and_privacy: false
};
export const profileSlice = createSlice({
	name: 'profile',
	initialState,
	reducers: {
		setProfile: (state, action: PayloadAction<ProfileState>) => {
			console.debug(state);
			return action.payload as ProfileState;
		},
		setFavoriteProducts: (
			state,
			{ payload }: PayloadAction<Array<FavoriteProduct>>
		) => {
			state.favorite_products = payload;
		},
		setCard: (state, { payload }: PayloadAction<Array<Card>>) => {
			state.cards = payload;
		},
		updateCard: (state, { payload }: PayloadAction<Card>) => {
			const newCardArray = [...state.cards].filter(
				card => card.id !== payload.id
			);
			state.cards = [...newCardArray, payload];
		},
		logout: () => {
			return initialState as ProfileState;
		}
	}
});

export const { setProfile, setFavoriteProducts, setCard, updateCard, logout } =
	profileSlice.actions;
export default profileSlice.reducer;
